module.exports = __webpack_public_path__ + "static/media/proxy-gen.5061d5af.svg";